// extracted by mini-css-extract-plugin
export default {"container":"NexsetDetail_container__38SgW","header":"NexsetDetail_header__7ez1f","tabs":"NexsetDetail_tabs__L0lMI","actions":"NexsetDetail_actions__3DLvD"};